// src/components/auth/CustomAuthTemplate.js

import React from 'react'
import PropTypes from 'prop-types'
import { InteractionType } from '@azure/msal-browser'
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react'

import { clearMsalBrowserStorage, loginRequest } from './authConfig'

function ErrorComponent({ error }) {
  const { instance } = useMsal()

  const errorMessage = error?.errorMessage || error?.message || 'Unable to sign in.'

  const resetSignIn = () => {
    clearMsalBrowserStorage({ keepAuthCacheVersion: false })
    instance.setActiveAccount(null)
    window.location.assign('/')
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h5>Authentication error</h5>

      <p>{errorMessage}</p>

      <p>Your browser may have an old cached B2C/MSAL login from a previous policy or tenant.</p>

      <button type="button" onClick={resetSignIn}>
        Clear sign-in cache and try again
      </button>
    </div>
  )
}

ErrorComponent.propTypes = {
  error: PropTypes.shape({
    errorMessage: PropTypes.string,
    message: PropTypes.string,
  }),
}

function LoadingComponent() {
  return <h6>Authentication in progress...</h6>
}

const CustomAuthTemplate = ({ children }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={ErrorComponent}
      loadingComponent={LoadingComponent}
    >
      {children}
    </MsalAuthenticationTemplate>
  )
}

CustomAuthTemplate.propTypes = {
  children: PropTypes.node,
}

export default CustomAuthTemplate
